/**  @jsx jsx */
import { jsx } from '@emotion/core';
import { ellipsisStyle } from '../styles';
export default function renderEllipsis(_ref) {
  var key = _ref.key;
  return jsx("span", {
    key: key,
    css: ellipsisStyle
  }, "...");
}